import AxiosClient from "../../services/axios.services";

class CompanyResponsibles {
  //api para obtener los registros de roles empresas en el mantenimiento.
  getCompanyResponsible = (params) =>
    AxiosClient.get(
      "/api/app/roles_usuario_empresa/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  //api para mostrar las empresas del usuario en los desplegables. No afecta el rol de responsable_rol_empresas
  getCompanyResponsibleSelects = (params) =>
    AxiosClient.get(
      "/api/app/roles_usuario_empresa_2/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getCompanyResponsibleByID = (id) =>
    AxiosClient.get(
      `/api/app/roles_usuario_empresa/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveCompanyResponsible = (data) =>
    AxiosClient.post(
      "/api/app/roles_usuario_empresa/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editCompanyResponsible = (id, data) =>
    AxiosClient.put(
      `/api/app/roles_usuario_empresa/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteCompanyResponsible = (id) =>
    AxiosClient.delete(
      `/api/app/roles_usuario_empresa/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new CompanyResponsibles();
